import type { MenuItemProps } from "@mui/material";
import { Box, ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import type { ReactNode } from "react";
import BadgeDetached from "@entrilia/shared/components/BadgeDetached";

interface Props extends MenuItemProps {
  text: string;
  Icon?: ReactNode;
  badgeCount?: number;
}

const VerticalNavigationMenuItem = ({ Icon, text, badgeCount, ...menuItemProps }: Props) => (
  <MenuItem {...menuItemProps}>
    {Icon && <ListItemIcon>{Icon}</ListItemIcon>}
    <ListItemText slotProps={{ primary: { noWrap: true } }}>{text}</ListItemText>
    {badgeCount !== undefined && (
      <Box>
        <BadgeDetached badgeContent={badgeCount} color={menuItemProps.selected ? "primary" : "secondary"} showZero />
      </Box>
    )}
  </MenuItem>
);

export default VerticalNavigationMenuItem;
